module.exports = __webpack_public_path__ + "img/banner.5bd9cca2.png";